import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRightIcon, MapPinIcon, MenuIcon, XIcon } from "lucide-react";
import { Logo } from "./Logo";
import { navigation } from "../data/company";
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 w-full bg-white/95 backdrop-blur" data-id="element-45" data-mp="2ni7ijhdjjnkw">
      <div className="mx-auto flex h-20 max-w-[1440px] items-center justify-between gap-6 px-5 lg:px-8" data-id="element-46" data-mp="2rlm8p0v71kc2">
        <Logo data-id="element-47" data-mp="2wjfie3vpgwh3" />

        <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-48" data-mp="2wivwyd6ujpyb">
          <ul className="flex items-center gap-9" data-id="element-49" data-mp="31cqpm64fjf9j">
            {navigation.map(item => <li key={item.to} data-id="element-50" data-mp="36aij34kq39fu">
                <NavLink to={item.to} end className={({
              isActive
            }) => `whitespace-nowrap text-[15px] font-medium transition-colors duration-150 hover:text-accent ${isActive ? "text-accent" : "text-ink/80"}`} data-id="element-51" data-mp="3ba4v5aotejn2">
                  {item.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="hidden items-center gap-6 lg:flex" data-id="element-52" data-mp="2mnpzgrx9hjof">
          <span className="flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-ink" data-id="element-53" data-mp="2hnlhsykmaiwm">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-tint text-accent" data-id="element-54" data-mp="3fbcc0pogvynf">
              <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="3abponnexd20w" />
            </span>
            Meaux · 77100
          </span>
          <span className="h-8 w-px bg-line" aria-hidden="true" data-id="element-56" data-mp="35khhyz4zburf" />
          <Link to="/contact" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-ink px-6 py-3 text-sm font-semibold text-white transition-colors duration-150 hover:bg-ink-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-57" data-mp="30mpm5u17rohy">
            Devis gratuit
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" data-mp="1recwlk5a71m3" />
          </Link>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} className="flex h-11 w-11 items-center justify-center rounded-full bg-surface text-ink lg:hidden" data-id="element-59" data-mp="1wbv18yc9muoa">
          {open ? <XIcon className="h-5 w-5" data-id="element-60" data-mp="1cp6rxgnocj6t" /> : <MenuIcon className="h-5 w-5" data-id="element-61" data-mp="1cpgk9aw6z2fo" />}
        </button>
      </div>

      <AnimatePresence data-id="element-62" data-mp="ypp87fp8jw4b">
        {open && <motion.nav id="mobile-menu" aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-white px-5 pb-6 pt-2 lg:hidden" data-id="element-63" data-mp="yqqivj2cagli">
            <ul className="flex flex-col" data-id="element-64" data-mp="mf6acp6x304y">
              {navigation.map(item => <li key={item.to} data-id="element-65" data-mp="hgwesdha5xit">
                  <NavLink to={item.to} end onClick={() => setOpen(false)} className={({
              isActive
            }) => `block border-b border-line py-3.5 text-base font-semibold ${isActive ? "text-accent" : "text-ink"}`} data-id="element-66" data-mp="hdh03briqqhx">
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
            <Link to="/contact" onClick={() => setOpen(false)} className="mt-5 flex items-center justify-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm font-semibold text-white" data-id="element-67" data-mp="1f20svgk6bpfs">
              Demander un devis gratuit
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-68" data-mp="3bwdqjrdk2oj5" />
            </Link>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}